import { TradierSymbolParser } from './tradier-symbol/TradierSymbolParser';

const parseStrikeFromSymbol = (input: string): number => {
  const parsed = new TradierSymbolParser(input).parsed;

  if (!parsed?.strike) {
    throw new Error(`Could not parse strike from symbol: ${input}`);
  }

  return parsed.strike;
};

export default parseStrikeFromSymbol;
